import clsx from "clsx";
import st from "@/styles/Ui.module.scss"
import NoPictureIcon from "@/svg/NoPictureIcon.tsx";

interface Props {
    className?: string
}

const NoImgContainer:React.FC<Props> = ({className}) => {
    
    
    return (
        <div className={clsx(className && className, st.no_img_container)}>
            <NoPictureIcon />
        </div>
    )
}

export default NoImgContainer